let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("76n7a"), load("l253H"), load("aYwRc")]).then(() => parcelRequire('6Pefo'));